module.exports = __webpack_public_path__ + "img/bus-station.9c31c3a0.svg";